import { confirmUserBlockI18n } from './confirm-user-block';
import { filtersI18n } from './filters';
import { userFormI18n } from './user-form';

export const ruRu = (__LOCALE_RU__ ? ({
  ...confirmUserBlockI18n.ruRu,
  ...filtersI18n.ruRu,
  ...userFormI18n.ruRu,
}) : {}) as Record<string, unknown>;

export const en = (__LOCALE_EN__ ? ({
  ...confirmUserBlockI18n.en,
  ...filtersI18n.en,
  ...userFormI18n.en,
}) : {}) as Record<string, unknown>;

export const esEs = (__LOCALE_ESES__ ? ({
  ...confirmUserBlockI18n.esEs,
  ...filtersI18n.esEs,
  ...userFormI18n.esEs,
}) : {}) as Record<string, unknown>;

export const ptBr = (__LOCALE_PTBR__ ? ({
  ...confirmUserBlockI18n.ptBr,
  ...filtersI18n.ptBr,
  ...userFormI18n.ptBr,
}) : {}) as Record<string, unknown>;
